import React, { memo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SmartButton from '../../../shared/components/SmartButton';
import Rating from './Rating';
import TextAreaField from '../../../shared/components/form/TextAreaField';

const Survey = ({ t, survey, onSubmit }) => {
  const [rating, setRating] = useState(null);
  const [observation, setObservation] = useState();

  return (
    <div className="form d-flex flex-column">
      <div className="form__form-group d-flex justify-content-center">
        <span className="font-weight-bold h6 form__form-group-label">
          {survey.title}
        </span>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{survey.description}</span>
        <div className="form__form-group-field">
          <Rating ratingValue={rating} onChange={(value) => setRating(value)} />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.then-in-comments')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="observation"
            type="text"
            component={TextAreaField}
            maxLength="500"
            onChange={({ target }) => setObservation(target.value)}
            placeholder={t('general.placeholders.type-here')}
          />
        </div>
      </div>
      <div className="form__form-group d-flex justify-content-center mb-0">
        <SmartButton
          className="mb-0"
          color="primary"
          label={t('general.save')}
          disabled={rating === null}
          onClick={() => onSubmit({ survey, score: rating, observation })}
        />
      </div>
    </div>
  );
};

Survey.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  survey: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default withTranslation('common')(memo(Survey));
